import { Injectable } from '@angular/core';
import { SocketMiddlewareService } from './socket-middleware.service';
import { Subject, takeUntil } from 'rxjs';
import { DashboardSocketCommands } from 'ops/common/io-event/websocket-message';
import { DashboardView } from 'ops/common/models/dashboard-view';

@Injectable({ providedIn: 'root' })
export class DashboardSocketService {
    destroySubscriptions$: Subject<void> = new Subject();
    updateDashboard$: Subject<DashboardView> = new Subject<DashboardView>();

    constructor(private socketService: SocketMiddlewareService) {}

    startSubscriptions() {
        this.subscribeToEvent(this.dashboardCreated());
        this.subscribeToEvent(this.dashboardUpdated());
    }

    private subscribeToEvent(event$) {
        event$.pipe(takeUntil(this.destroySubscriptions$)).subscribe((newDashboard) => {
            const dashboard = {
                id: newDashboard.id,
                panels: [
                    newDashboard.panel0,
                    newDashboard.panel1,
                    newDashboard.panel2,
                    newDashboard.panel3,
                ],
            };
            this.updateDashboard$.next(dashboard);
        });
    }

    destroySubscriptions() {
        this.destroySubscriptions$.next();
        this.destroySubscriptions$.complete();
    }

    updateListSubject(): Subject<DashboardView> {
        return this.updateDashboard$;
    }

    dashboardCreated() {
        return this.socketService.receiveMessageObserver(DashboardSocketCommands.PANEL_CREATED);
    }

    dashboardUpdated() {
        return this.socketService.receiveMessageObserver(DashboardSocketCommands.PANEL_UPDATED);
    }
}
